import { makeBenefitsApi } from 'src/http/api/internal/internal-http';
import { EventsRepository } from 'src/repositories/benefits/events.repository';
import {
  EventListFilters,
  eventManager,
  eventsTypeItem,
  EventsListResponse,
} from 'src/types/events';
// import { api } from 'src/utils/axios';
import { create } from 'zustand';

type States = {
  isLoadingEventsList: boolean;
  isLoadingEventDetails: boolean;
  isLoadingCreateEvent: boolean;
  eventsList: EventsListResponse;
  eventDetails: eventManager | null;
};

type Actions = {
  getEventsList: (
    searchText: string,
    filters: EventListFilters,
    sortModel: { field: string; sort?: 'asc' | 'desc' | null } | null,
    paginationModel: { page: number; pageSize: number }
  ) => Promise<void>;
  getEventDetails: (id: string) => Promise<void>;
  resetEventDetails: () => void;
  createUpdateEvent: (event: eventManager) => Promise<void>;
  exportData: (ids: string[], userName: string) => Promise<void>;
};

type Events = Actions & States;

const emptyEventsList: EventsListResponse = {
  data: [],
  total: 0,
  totalFiltered: 0,
  returnedCount: 0,
  page: 0,
  pageSize: 10,
  totalPages: 0,
};

const initialValues = {
  isLoadingEventsList: false,
  isLoadingEventDetails: false,
  isLoadingCreateEvent: false,
  eventsList: emptyEventsList,
  eventDetails: null,
};

const eventsRepository = new EventsRepository(makeBenefitsApi());

export const useEventsStore = create<Events>((set: any, get: any) => ({
  ...initialValues,

  getEventsList: async (searchText, filters, sortModel, paginationModel) => {
    set({ isLoadingEventsList: true });

    try {
      const response = await eventsRepository.getEventsList({
        search: searchText,
        filters: JSON.stringify(filters),
        sort: JSON.stringify(sortModel),
        page: paginationModel.page,
        pageSize: paginationModel.pageSize,
      });

      if (response.isLeft()) {
        set({ isLoadingEventsList: false });
        throw new Error(response.value.message);
      }

      const responseValue = response.value || emptyEventsList;
      const data = Array.isArray(responseValue) ? responseValue : responseValue.data || [];

      set({
        eventsList: Array.isArray(responseValue)
          ? {
              ...emptyEventsList,
              data: responseValue as eventsTypeItem[],
              total: responseValue.length,
              totalFiltered: responseValue.length,
              returnedCount: responseValue.length,
            }
          : {
              ...emptyEventsList,
              ...responseValue,
              data,
            },
        isLoadingEventsList: false,
      });
    } catch (error) {
      set({ isLoadingEventsList: false });

      if (error instanceof Error) {
        throw error;
      }

      throw new Error('Erro ao carregar experiências');
    }
  },

  getEventDetails: async (id: string) => {
    set({ isLoadingEventDetails: true });
    const response = await eventsRepository.getEventDetails(id);

    if (response.isLeft()) {
      set({ isLoadingEventDetails: false });
      throw new Error(response.value.message);
    } else {
      set({ eventDetails: response.value, isLoadingEventDetails: false });
    }
  },

  resetEventDetails: () => {
    set({ eventDetails: null });
  },

  createUpdateEvent: async (event) => {
    set({ isLoadingCreateEvent: true });

    try {
      const response = await eventsRepository.createUpdateEvent(event);

      if (response.isLeft()) {
        throw new Error(response.value.message);
      } else {
        set({ isLoadingCreateEvent: false });
      }
    } catch (error) {
      set({ isLoadingCreateEvent: false });

      if (error instanceof Error) {
        throw error;
      }

      throw new Error('Erro ao salvar evento');
    }
  },

  exportData: async (ids: string[], userName: string) => {
    await eventsRepository.exportEvent(ids, userName);
  },
}));
